import api from "./api";
import store from '@/store';
const SERVICE_URL = "merchant-service/token/customer-portal";

export default {
  merchantToken() {
    return store.getters['merchantToken/merchantToken']
  },
  getMerchantToken(payload) {
    return new Promise((resolve, reject) => {
      api.post(
        `${SERVICE_URL}`,
        payload
      )
        .then(response => {
          return resolve(response && response.token ? response.token : null);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  }
}
